import { toast } from "react-toastify";
import { fetchBusinessProfileFailure,fetchBusinessProfileSuccess } from "./reducer";
import { setEditSuccessMessage } from "../../toastMessage/action";
import { EDIT_PARTNER_API, OPERATOR_CREATE_AND_EDIT_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { fetchOperatorbyId } from "../GetOperatorbyID/thunk";


export const editBusinessProfile = (jsonObj, operatorId, setLoading, navigate,  setEditData) => async (dispatch) => {
    setLoading(true)
    const initialValues = {};
    const operatorOptions = [];
    const OperatorStatusOptions = [];
    const roleName = localStorage.getItem('roleName') 
    const isPartner = roleName === 'EVPartnerAdmin' || roleName === 'ISPPartnerAdmin' || roleName === 'partnerAdmin';
    const url = isPartner ? `${EDIT_PARTNER_API}?id=${operatorId}` : `${OPERATOR_CREATE_AND_EDIT_API}/${operatorId}`;
    await determineBaseUrlAndPerformApiCall(url, 'PATCH', jsonObj).then((response) => {
        if (response.error) {
            dispatch(fetchBusinessProfileFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
        if (!response.error) {
            setLoading(false)
            dispatch(fetchBusinessProfileSuccess(response))
            if (roleName === "systemUser") {
                // navigate('/operator-listing');
                dispatch(setEditSuccessMessage(true))
            }
            else if (roleName !== "systemUser") {
                dispatch(fetchOperatorbyId(setLoading, operatorId, initialValues, operatorOptions, OperatorStatusOptions, setEditData, isPartner));
                navigate('/dashboard');
                dispatch(setEditSuccessMessage(true))
            }
        }
    }).catch((errorResp) => {console.error("[Error in the EditBusinessProfile method",errorResp)})
};